import {checkIfSauceEmployee} from 'helpers/constants/restrictions';

export const isLocationClosedForBookADriver = (location) =>
  Boolean(location?.ClosedManually) && !location?.ClosedManuallyUntilTime;

export const shouldBlockBookADriverForClosedLocation = (location) =>
  !checkIfSauceEmployee() && isLocationClosedForBookADriver(location);
